import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileSelectPrompt", "fileRow", "fileName"]

  declare fileSelectPromptTarget: HTMLElement
  declare fileRowTarget: HTMLElement
  declare fileNameTarget: HTMLElement

  connect() {
    this.syncFileInput()
  }

  dragOver(event: DragEvent) {
    event.preventDefault()
    this.toggleHighlight(true)
  }

  dragLeave(event: DragEvent) {
    // 子要素への移動でも dragleave が発火するため、ゾーン外へ出たときだけ解除する
    if (event.relatedTarget instanceof Node && this.element.contains(event.relatedTarget)) return
    this.toggleHighlight(false)
  }

  drop(event: DragEvent) {
    event.preventDefault()
    this.toggleHighlight(false)
    if (event.dataTransfer.files.length !== 1) {
      alert('ファイルは一つだけアップロード可能です')
      return
    }
    this.fileInput.files = event.dataTransfer.files
    this.dispatchChange()
  }

  change() {
    this.syncFileInput()
  }

  clear() {
    this.fileInput.value = ''
    this.dispatchChange()
  }

  private syncFileInput() {
    const file = this.fileInput.files[0]
    this.toggleRow(this.fileSelectPromptTarget, !file)
    this.toggleRow(this.fileRowTarget, !!file)
    this.fileNameTarget.textContent = file ? file.name : ''
  }

  private toggleHighlight(active: boolean) {
    this.element.classList.toggle('tw-border-gray-400', !active)
    this.element.classList.toggle('tw-bg-white', !active)
    this.element.classList.toggle('tw-border-sky-400', active)
    this.element.classList.toggle('tw-bg-sky-50', active)
  }

  private toggleRow(row: HTMLElement, visible: boolean) {
    row.classList.toggle('tw-flex', visible)
    row.classList.toggle('tw-hidden', !visible)
  }

  private dispatchChange() {
    this.fileInput.dispatchEvent(new Event('change', { bubbles: true }))
  }

  private get fileInput(): HTMLInputElement {
    return this.element.querySelector('input[type="file"]')
  }
}
